export default __webpack_public_path__ + "static/media/solucao-05.de48d848.webp";